// src/features/automacaodeemails/AutomacaoEmailsPage.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AutomacaoEmailsLayout from "./components/AutomacaoEmailsLayout";
import AutomacaoHome from "./pages/AutomacaoHome";
import ScreensPage from "./pages/ScreensPage";
import AutomationsPage from "./pages/AutomationsPage";
import AutomationWizard from "./pages/AutomationWizard";
import LogsPage from "./pages/LogsPage";
import SettingsPage from "./pages/SettingsPage";
import AssetsPage from "./pages/AssetsPage";

export default function AutomacaoEmailsPage({ onBack }) {
  return (
    <Routes>
      <Route element={<AutomacaoEmailsLayout onBack={onBack} />}>
        <Route index element={<AutomacaoHome />} />
        <Route path="screens" element={<ScreensPage />} />
        <Route path="automations" element={<AutomationsPage />} />
        <Route path="wizard" element={<AutomationWizard />} />
        <Route path="wizard/:id" element={<AutomationWizard />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="assets" element={<AssetsPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Route>
    </Routes>
  );
}
